export const visit = (vm, at) => {
at({ "en": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "View pricing" } } } } });
};